// extracted by mini-css-extract-plugin
module.exports = {"container":"Pager_container__3TcOz","current":"Pager_current__1iUCl","next":"Pager_next__UP-Rr"};